import { useMemo } from "react";
import { useLoyaltyStore } from "stores/loyalty";
import LoyaltyListRanks from "components/organisms/LoyaltyListRanks";
import { useGetProgressLoyalty } from "queries/useGetProgressLoyalty";
import { mapRanksToCard } from "utils/loyalty";
import { useGetUserProgressLoyalty } from "../../queries/useGetUserProgressLoyalty";

const LoyaltyListRanksContainer = () => {
  const { activeIndex, setIndexActiveRank } = useLoyaltyStore((state) => ({
    activeIndex: state.indexActiveRank,
    setIndexActiveRank: state.setIndexActiveRank,
  }));
  const { data: loyaltyUser } = useGetUserProgressLoyalty();
  const { data: progressUser } = useGetProgressLoyalty();

  const userExperience = progressUser?.data?.data?.experience || 0;

  const ranksCards = useMemo(
    () => mapRanksToCard(loyaltyUser?.ranks, userExperience),
    [userExperience, loyaltyUser?.ranks],
  );

  const handleClickCard = (index: number) => setIndexActiveRank(index);

  return (
    <LoyaltyListRanks
      activeIndex={activeIndex}
      ranks={ranksCards}
      onClickCard={handleClickCard}
    />
  );
};

export default LoyaltyListRanksContainer;
